<p></p>
<div class="card width100 container">

    <div>
        <h3 class="text-center pad-top pad-bottom">Admin Login</h3>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="login()" class="form-horizontal">
        <div *ngIf="errorMsg.length > 0" class="alert alert-danger">
            {{ errorMsg }}
        </div>
        <div class="form-group form-row">
            <label for="email" class="col-sm-2">Email:</label>
            <input type="email" formControlName="email" autocomplete="username" class="form-control col-sm-10"
                id="email">
        </div>

        <div class="form-group form-row">
            <label for="password" class="col-sm-2">Password:</label>
            <input type="password" formControlName="password" autocomplete="current-password"
                class="form-control col-sm-10" id="password">
        </div>

        <div class="form-group">
            <button type="submit" [disabled]="loginForm.invalid" class="btn btn-success btn-block">Login</button>
        </div>
    </form>
</div>
